import { usePlanningTranslation } from '@libs/utils/translations'
import type { FC } from 'react'
import React, { useCallback } from 'react'
import { useDispatch } from 'react-redux'

import { entitiesActions } from '../../redux/modules/entities'
import { DropItem } from '../common'
import type { DragItemType } from '../constant'
import { DND_TYPE } from '../constant'

type Props = {
  day: string
  weeklyscheduleId: number
}

const DropItemNoteCopy: FC<Props> = ({ day, weeklyscheduleId }) => {
  const dispatch = useDispatch()
  const { t } = usePlanningTranslation()

  const handleDrop = useCallback(
    (item: DragItemType) =>
      dispatch(
        entitiesActions.copyNote({
          noteId: item.id,
          to: {
            weeklyscheduleId,
            date: day
          }
        })
      ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  )

  return (
    <DropItem accept={DND_TYPE.NOTE} onDrop={handleDrop}>
      {t('weekly.header.copyNote')}
    </DropItem>
  )
}

export default DropItemNoteCopy
